import React from 'react'

const AlertCircleOutline = props => (
  <svg
    viewBox='0 0 20 20'
    width={props.width || '20px'}
    height={props.height || '20px'}
  >
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g fill={props.color || '#000'} fillRule='nonzero'>
        <path d='M10,0 C12.6521649,0 15.195704,1.0535684 17.0710678,2.92893219 C18.9464316,4.80429597 20,7.3478351 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 2.22044605e-15,15.5228475 2.22044605e-15,10 C2.22044605e-15,4.4771525 4.4771525,0 10,0 Z M10,2 C5.581722,2 2,5.581722 2,10 C2,14.418278 5.581722,18 10,18 C12.1217319,18 14.1565632,17.1571453 15.6568542,15.6568542 C17.1571453,14.1565632 18,12.1217319 18,10 C18,5.581722 14.418278,2 10,2 Z M10,13 C10.5522847,13 11,13.4477153 11,14 C11,14.5522847 10.5522847,15 10,15 C9.44771525,15 9,14.5522847 9,14 C9,13.4477153 9.44771525,13 10,13 Z M10,5 C10.5522847,5 11,5.44771525 11,6 L11,6 L11,11 C11,11.5522847 10.5522847,12 10,12 C9.44771525,12 9,11.5522847 9,11 L9,11 L9,6 C9,5.44771525 9.44771525,5 10,5 Z' />
      </g>
    </g>
  </svg>
)

export default AlertCircleOutline
